<div class="w-full">
  <swiper-container
    [pagination]="true"
    navigation="true"
    autoplay="true"
    class="shadow-md shadow-[#79273a]"
  >
    <swiper-slide
      *ngFor="let item of banerImg; let i = index"
      class="swiperSlide"
    >
      <!-- <img
        [src]="bannerImageUrl + item?.image"
        [alt]="item?.title"
        class="w-full rounded-b-lg h-40 sm:h-64 md:h-80 lg:h-[25rem] xl:h-[28rem]"
        (click)="getProductById(item)"
      /> -->

      <!-- [src]="getWebpImage(item?.image)" -->
      <img
        [src]="bannerImageUrl + item?.image"
        [alt]="item?.title"
        [attr.loading]="i === 0 ? 'eager' : 'lazy'"
        [attr.fetchpriority]="i === 0 ? 'high' : 'low'"
        decoding="async"
        class="w-full rounded-b-lg h-40 sm:h-64 md:h-80 lg:h-[25rem] xl:h-[28rem]"
        (click)="getProductById(item)"
      />
    </swiper-slide>
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
  </swiper-container>
</div>
